import { toast } from "react-toastify";
import { AccountEditor } from "../../../../../../../modules/editor/AccountEditor";
import { _PayrollEntityProperties, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";
import { CRSelectorConstants } from "../../../../../../../modules/bpm/config/Componentes/CRSelectorConstants";
import { BankingAccountEditor } from "../../../../../../../modules/Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/BankingAccountSelect";
import { BakingEntityEditor } from "../../../../../../../modules/erp/cellEditor/BankingEntity/BankingEntitySelect";
import { InputDate } from "../../../../../../../modules/theme/Input/InputDate";
import { PayrollEntitySelect } from "../../../../../../../modules/admin/CreditPotfolio/PayrollEntity/PayRollEntitySelect";
import { CountryEditor } from "./CountryEditor";
import { DepartamentCitiesEditor } from "./DepartamentCitiesEditor";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { useEffect } from "react";
import { PrintJson } from "../../../../../../../modules/theme/Component/PrintJson";

interface PersonalInfoTabProps {
    bean: any;
    setBean: Function;
    props: any;
    setProps: Function;
    missingFields: string[];
    setMissingFields: Function;
    updateAffiliate: Function;
    getTimeDiffText: (fechaInicio: string | Date) => string;
    cannotEdit?: boolean;
}

export const PersonalInfoTab = ({
    bean,
    setBean,
    missingFields,
    updateAffiliate,
    getTimeDiffText,
    setMissingFields,
    cannotEdit,
}: PersonalInfoTabProps) => {

    const validateForm = () => {
        const requiredFields: string[] = [];
        const missing = requiredFields.filter(field => !bean[field]);
        setMissingFields(missing);
        return missing.length;
    };

    const handleSave = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
        } else {
            updateAffiliate();
        }
    };

    const { instance, lista, setLista } = useDataBean(_PayrollEntityProperties);

    useEffect(() => {
        if (bean.IDCajaNominadora) {
            getPersonTypeList(bean.IDCajaNominadora);
            if (bean.IDCajaNominadora != _single.getAffiliate()?.IDCajaNominadora) {
                setBean({ ...bean, IDGradoPersona: null, TypeAccount: "" })
            }
        }
    }, [bean.IDCajaNominadora])

    const getPersonTypeList = (idPayrrol: number) => {
        const pops = {
            IDPayrollEntity: idPayrrol
        }
        instance.getPayrollEntityPropertiesCatalogPorPropiedades(pops, null).then(
            (resp) => {
                if (resp.length > 0) {
                    const x = resp[0].DataBeanProperties;
                    if (x.CodeTypePersons) {
                        setLista(x.CodeTypePersons ? JSON.parse(x.CodeTypePersons) : [])
                    }
                } else {
                    setLista([]);
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <h4>Datos Personales</h4>
                </div>
                <div className="row" >
                    <div className="col-lg-12">
                        <AccountEditor idAccount={bean.IDAccount} label="Cuenta Usuario" disabled onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount, PrimerApellido: e.Surname1, PrimerNombre: e.Name1, SegundoApellido: e.Surname2, SegundoNombre: e.Name2 }); console.log(e) }} />
                    </div>

                    <div className="col-lg-3">
                        <label >Primer Nombre</label>
                        <input type="text" className="form-control" value={bean.PrimerNombre} disabled />
                    </div>
                    <div className="col-lg-3">
                        <label >Segundo Nombre</label>
                        <input type="text" className="form-control" value={bean.SegundoNombre} disabled />
                    </div>
                    <div className="col-lg-3">
                        <label >Primer Apellido</label>
                        <input type="text" className="form-control" value={bean.PrimerApellido} disabled />
                    </div>
                    <div className="col-lg-3">
                        <label >Segundo Apellido</label>
                        <input type="text" className="form-control" value={bean.SegundoApellido} disabled />
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <label className={`${missingFields.includes('Identification') ? 'has-error' : ''}`}>Nº Documento</label>
                        <input type="text" className="form-control" value={bean.Nit} disabled />
                    </div>
                    <div className={`col-lg-4 ${missingFields.includes('IDTipoIdentificacion') ? 'has-error' : ''}`}>
                        <CRSelectorConstants label="Tipo de Documento" idSelector={bean.IDTipoIdentificacion} groupDefinition="DOCUMEN" onChange={(e: any) => { setBean({ ...bean, 'IDTipoIdentificacion': e }) }} />
                    </div>
                    <div className={`col-lg-4 ${missingFields.includes('FechaExpedicion') ? 'has-error' : ''}`}>
                        <InputDate name="desde" label="Fecha de Expedición :" value={bean.FechaExpedicion} setDate={(e: any) => { setBean({ ...bean, "FechaExpedicion": e }) }} />
                    </div>

                    <div className="col-lg-4">
                        <label className={` ${missingFields.includes('CiudadExpedicionIDLn') ? 'has-error' : ''}`}>Ciudad de Expedición del documento de identidad:</label>
                        <DepartamentCitiesEditor idSelector={bean.CiudadExpedicionIDLn} onChange={(e) => { setBean({ ...bean, "CiudadExpedicionIDLn": e.IDCities }) }} label=" " />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('IDPaisNacimiento') ? 'has-error' : ''}`}>
                        <label className="form-label">Pais Nacimiento:</label>
                        <CountryEditor idSelector={bean.IDPaisNacimiento} onChange={(e) => { setBean({ ...bean, "IDPaisNacimiento": e.IDCountries }) }} label=" " />
                    </div>

                    <div className="col-lg-4">
                        <label className={`form-label ${missingFields.includes('CiudadNacimientoIDLn') ? 'has-error' : ''}`}>Ciudad de Nacimiento:</label>
                        <DepartamentCitiesEditor idSelector={bean.CiudadNacimientoIDLn} idCountry={bean.IDPaisNacimiento} onChange={(e) => { setBean({ ...bean, "CiudadNacimientoIDLn": e.IDCities }) }} label=" " />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('FechaNacimiento') ? 'has-error' : ''}`}>
                        <InputDate name="desde" label="Fecha de Nacimiento:" value={bean.FechaNacimiento} setDate={(e: any) => { setBean({ ...bean, "FechaNacimiento": e }) }} />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('IDGenero') ? 'has-error' : ''}`}>
                        <CRSelectorConstants label="Genero" idSelector={bean.IDGenero} groupDefinition="TIPGENERO" onChange={(e: any) => { setBean({ ...bean, 'IDGenero': e }) }} />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('IDEstadoCivil') ? 'has-error' : ''}`}>
                        <CRSelectorConstants label="Estado Civil" idSelector={bean.IDEstadoCivil} groupDefinition="TIPESTADO" onChange={(e: any) => { setBean({ ...bean, 'IDEstadoCivil': e }) }} />
                    </div>
                </div>


                <div className="row">

                    <div className={`col-lg-4 ${missingFields.includes('IDCajaNominadora') ? 'has-error' : ''}`}>
                        <PayrollEntitySelect
                            idSelector={bean.IDCajaNominadora}
                            onChange={(e: any) => { setBean({ ...bean, 'IDCajaNominadora': e }) }}
                        />
                    </div>

                    {bean.IDCajaNominadora ?
                        <div className="col-md-4">
                            <label >Tipo de Persona</label>
                            <select
                                className="form-select"
                                value={bean.TypeAccount}
                                onChange={(e) => setBean({ ...bean, "TypeAccount": e.target.value })}
                            >
                                <option value="">...</option>
                                {lista.map((item) => (
                                    <option key={item.IDCreditProperties} value={item.PropertyValue}>
                                        {item.Description}
                                    </option>
                                ))}
                            </select>
                        </div>
                        :
                        null
                    }

                    {(bean.TypeAccount == 2) &&
                        <div className={`col-lg-4 ${missingFields.includes('IDGradoPersona') ? 'has-error' : ''}`}>
                            <CRSelectorConstants label="Grado" idSelector={bean.IDGradoPersona} groupDefinition="LISTCIVIL" onChange={(e: any) => { setBean({ ...bean, 'IDGradoPersona': e }) }} />
                        </div>
                    }

                    {(bean.TypeAccount == 1 || bean.TypeAccount == 3) &&
                        <div className={`col-lg-4 ${missingFields.includes('IDGradoPersona') ? 'has-error' : ''}`}>
                            <CRSelectorConstants label="Grado" idSelector={bean.IDGradoPersona} groupDefinition="GRADOSPOL" onChange={(e: any) => { setBean({ ...bean, 'IDGradoPersona': e }) }} />
                        </div>
                    }

                    <div className={`col-lg-4 ${missingFields.includes('FechaInicioServicio') ? 'has-error' : ''}`}>
                        <InputDate name="FechaInicioServicio" label="Tiempo de Servicio:" value={bean.FechaInicioServicio} setDate={(e: any) => { setBean({ ...bean, "FechaInicioServicio": e }) }} />
                        {bean.FechaInicioServicio && (
                            <small className="text-muted">
                                Tiempo de Servicio: <strong>{getTimeDiffText(bean.FechaInicioServicio)}</strong>
                            </small>
                        )}
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('Ocupacion') ? 'has-error' : ''}`}>
                        {/* <label className="form-label">Ocupación:</label>
                        <input
                            type="text"
                            className={`form-control ${missingFields.includes('Ocupacion') ? 'is-invalid' : ''}`}
                            value={bean.Ocupacion}
                            onChange={(e) => { setBean({ ...bean, "Ocupacion": e.target.value }) }}
                        /> */}
                        <CRSelectorConstants label="Ocupación" idSelector={bean.Ocupacion} groupDefinition="TIPOOCU" onChange={(e: any) => { setBean({ ...bean, 'Ocupacion': e }) }} />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('CorreoInstitucional') ? 'has-error' : ''}`}>
                        <label className="form-label">Correo Institucional:</label>
                        <input
                            type="email"
                            className={`form-control ${missingFields.includes('CorreoInstitucional') ? 'is-invalid' : ''}`}
                            value={bean.CorreoInstitucional}
                            onChange={(e) => { setBean({ ...bean, "CorreoInstitucional": e.target.value }) }}
                        />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('CorreoPersonal') ? 'has-error' : ''}`}>
                        <label className="form-label">Correo Personal:</label>
                        <input
                            type="email"
                            className={`form-control ${missingFields.includes('CorreoPersonal') ? 'is-invalid' : ''}`}
                            value={bean.CorreoPersonal}
                            onChange={(e) => { setBean({ ...bean, "CorreoPersonal": e.target.value }) }}
                        />
                    </div>
                </div>

                <hr className="mt-4" />
                <div className="row">
                    <h4>Datos de Contacto</h4>
                </div>
                <div className="row">
                    <div className={`col-lg-4 ${missingFields.includes('IDTipoVivienda') ? 'has-error' : ''}`}>
                        <CRSelectorConstants label="Tipo de Vivienda" idSelector={bean.IDTipoVivienda} groupDefinition="TIPVIVIENDA" onChange={(e: any) => { setBean({ ...bean, 'IDTipoVivienda': e }) }} />
                    </div>
                    <div className="col-lg-4">
                        <label className={` ${missingFields.includes('CiudadResidenciaIDLn') ? 'has-error' : ''}`}>Ciudad de Residencia:</label>
                        <DepartamentCitiesEditor idSelector={bean.CiudadResidenciaIDLn} onChange={(e) => { setBean({ ...bean, "CiudadResidenciaIDLn": e.IDCities }) }} label=" " />
                    </div>
                    <div className={`col-lg-4 ${missingFields.includes('DireccionResidencia') ? 'has-error' : ''}`}>
                        <label className="form-label">Dirección Residencial:</label>
                        <input type="text"
                            className={`form-control ${missingFields.includes('DireccionResidencia') ? 'is-invalid' : ''}`}
                            value={bean.DireccionResidencia}
                            onChange={(e) => { setBean({ ...bean, "DireccionResidencia": e.target.value }) }}
                        />
                    </div>
                    <div className={`col-lg-4 ${missingFields.includes('Barrio') ? 'has-error' : ''}`}>
                        <label className="form-label">Barrio</label>
                        <input type="text"
                            className={`form-control ${missingFields.includes('Barrio') ? 'is-invalid' : ''}`}
                            value={bean.Barrio}
                            onChange={(e) => { setBean({ ...bean, "Barrio": e.target.value }) }}
                        />
                    </div>
                    <div className={`col-lg-4 ${missingFields.includes('NumeroCelular') ? 'has-error' : ''}`}>
                        <label className="form-label">Celular:</label>
                        <input
                            type="tel"
                            className={`form-control ${missingFields.includes('NumeroCelular') ? 'is-invalid' : ''}`}
                            value={bean.NumeroCelular ?? bean.NUMERO_CELULAR}
                            onChange={(e) => { setBean({ ...bean, "NumeroCelular": e.target.value }) }}
                        />
                    </div>


                    <div className={`col-lg-4 ${missingFields.includes('TelefonoVivienda') ? 'has-error' : ''}`}>
                        <label className="form-label">Teléfono de Casa:</label>
                        <input
                            type="tel"
                            className={`form-control ${missingFields.includes('TelefonoVivienda') ? 'is-invalid' : ''}`}
                            value={bean.TelefonoVivienda}
                            onChange={(e) => { setBean({ ...bean, "TelefonoVivienda": e.target.value }) }}
                        />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('EstratoResidencia') ? 'has-error' : ''}`}>
                        <label className="form-label">Estrato</label>
                        <input
                            type="number"
                            className={`form-control ${missingFields.includes('EstratoResidencia') ? 'is-invalid' : ''}`}
                            value={bean.EstratoResidencia}
                            onChange={(e) => { setBean({ ...bean, "EstratoResidencia": e.target.value }) }}
                        />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('TelOficina') ? 'has-error' : ''}`}>
                        <label className="form-label">Teléfono oficina</label>
                        <input
                            type="tel"
                            className={`form-control ${missingFields.includes('TelOficina') ? 'is-invalid' : ''}`}
                            value={bean.TelOficina}
                            onChange={(e) => { setBean({ ...bean, "TelOficina": e.target.value }) }}
                        />
                    </div>

                    <div className={`col-lg-4 ${missingFields.includes('ExtensionOficina') ? 'has-error' : ''}`}>
                        <label className="form-label">Extensión</label>
                        <input
                            type="text"
                            className={`form-control ${missingFields.includes('ExtensionOficina') ? 'is-invalid' : ''}`}
                            value={bean.ExtensionOficina}
                            onChange={(e) => { setBean({ ...bean, "ExtensionOficina": e.target.value }) }}
                        />
                    </div>

                    <div className="col-md-12">
                        <label className={`${missingFields.includes('NombreConyuge') ? 'has-error' : ''}`}>Nombre cónyuge o compañero(a)</label>
                        <input type="text" className="form-control" placeholder="Nombre cónyuge o compañero(a)" value={bean.NombreConyuge} onChange={(e) => { setBean({ ...bean, NombreConyuge: e.target.value }) }} />
                    </div>
                    <div className="col-lg-3">
                        <label className={`${missingFields.includes('NitConyuge') ? 'has-error' : ''}`}>Nª Documento Conyuge</label>
                        <input type="number" className="form-control" placeholder="NIT o CC" value={bean.NitConyuge} onChange={(e) => { setBean({ ...bean, NitConyuge: e.target.value }) }} />
                    </div>
                    <div className={`col-lg-3 ${missingFields.includes('IDTipoIdentificacionConyuge') ? 'has-error' : ''}`}>
                        <CRSelectorConstants label="Tipo de Documento" idSelector={bean.IDTipoIdentificacionConyuge} groupDefinition="DOCUMEN" onChange={(e: any) => { setBean({ ...bean, 'IDTipoIdentificacionConyuge': e }) }} />
                    </div>
                    <div className={`col-lg-3 ${missingFields.includes('FechaExpedicionConyuge') ? 'has-error' : ''}`}>
                        <InputDate name="desde" label="Fecha de Expedición :" value={bean.FechaExpedicionConyuge} setDate={(e: any) => { setBean({ ...bean, "FechaExpedicionConyuge": e }) }} />
                    </div>
                    <div className="col-lg-3">
                        <label className={`${missingFields.includes('TelefonoConyuge') ? 'has-error' : ''}`}>Telefono/Celular</label>
                        <input type="tel" className="form-control" placeholder="Telefono/Celular" value={bean.TelefonoConyuge} onChange={(e) => { setBean({ ...bean, TelefonoConyuge: e.target.value }) }} />
                    </div>
                </div>

                {/* <hr className="mt-4" />
                <div className="row">
                    <h4>Información Bancaria:</h4>
                </div>
                <div className="row">
                    <div className={`col-lg-3 ${missingFields.includes('IDBancoDesembolso') ? 'has-error' : ''}`}>
                        <BakingEntityEditor label="Entidad Bancaria" idSelector={bean.IDBancoDesembolso} onChange={(e) => { setBean({ ...bean, 'IDBancoDesembolso': e }) }} />
                    </div>
                    <div className={`col-lg-3 ${missingFields.includes('IDTipoCuenta') ? 'has-error' : ''}`}>
                        <BankingAccountEditor label='Tipo de Cuenta' idSelector={bean.IDTipoCuenta} onChange={(e) => { setBean({ ...bean, 'IDTipoCuenta': e }) }} />
                    </div>
                    <div className={`col-lg-6 ${missingFields.includes('NumeroCuenta') ? 'has-error' : ''}`}>
                        <label className="form-label">No:</label>
                        <input
                            type="number"
                            className={`form-control ${missingFields.includes('NumeroCuenta') ? 'is-invalid' : ''}`}
                            value={bean.NumeroCuenta}
                            onChange={(e) => { setBean({ ...bean, "NumeroCuenta": parseInt(e.target.value) }) }}
                        />
                    </div>
                </div> */}
                {!cannotEdit &&
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <BasicButton
                                eventClick={handleSave}
                                icon="ri-save-line"
                                children="Guardar"
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};
